var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1105({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.25,11.13,1.73,5.41H2.5l.88,3.75c.09.39.17.79.24,1.17.14-.61.23-1,.26-1.06L5,5.41h.92l.82,2.9a15.75,15.75,0,0,1,.44,2c.08-.36.17-.77.29-1.24l.9-3.68h.76L7.52,11.13H6.79L5.58,6.77c-.1-.36-.16-.59-.18-.67-.06.26-.11.49-.17.67L4,11.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.8,11.13V5.41H12a6.15,6.15,0,0,1,.87,0,1.82,1.82,0,0,1,.71.27,1.3,1.3,0,0,1,.45.55,1.72,1.72,0,0,1,.18.78A1.77,1.77,0,0,1,13.7,8.3,2.22,2.22,0,0,1,12,8.81H10.55v2.32Zm.75-3H12a1.6,1.6,0,0,0,1-.27,1,1,0,0,0,.31-.77,1.05,1.05,0,0,0-.18-.62,1,1,0,0,0-.48-.34,3.61,3.61,0,0,0-.71,0H10.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1105);
export default __webpack_public_path__ + "static/media/Symbolpack_1_105.06253f11c8ad1e78e44c33f849b0f8d0.svg";
export { ForwardRef as ReactComponent };